import React from 'react'
import { useParams } from 'react-router-dom'
import { Spinner, Center, HStack, Button } from '@chakra-ui/react'
import { useEditResearch } from './hooks/useEditResearch'
import { EditResearchForm } from './components/EditResearchForm'
import TagManagementSection from './components/TagManagementSection'

const EditResearchPage: React.FC = () => {
  const { id } = useParams<{ id: string }>()

  const {
    // Data
    research,
    tags,
    selectedTags,
    newTagName,

    // State
    loading,
    saving,
    showTagError,
    canManageResearch,

    // Form
    register,
    handleSubmit,
    errors,
    isSubmitting,

    // Tag management
    setNewTagName,
    handleAddNewTag,
    handleRemoveTag,
    handleSelectTag,
    setShowTagError,

    // Navigation
    onCancel,
  } = useEditResearch(id)

  // Loading state
  if (loading) {
    return (
      <Center h='50vh'>
        <Spinner size='xl' color='blue.500' />
      </Center>
    )
  }

  // Permission check
  if (!canManageResearch) {
    return (
      <Center h='50vh'>
        <div>You don't have permission to edit research articles.</div>
      </Center>
    )
  }

  // Research not found
  if (!research) {
    return (
      <Center h='50vh'>
        <div>Research article not found.</div>
      </Center>
    )
  }

  return (
    <EditResearchForm
      onSubmit={handleSubmit}
      register={register}
      errors={errors}
    >
      {/* Tag Management Section */}
      <TagManagementSection
        tags={tags}
        selectedTags={selectedTags}
        newTagName={newTagName}
        showTagError={showTagError}
        saving={saving}
        setNewTagName={setNewTagName}
        handleSelectTag={handleSelectTag}
        handleRemoveTag={handleRemoveTag}
        handleAddNewTag={handleAddNewTag}
        setShowTagError={setShowTagError}
      />

      {/* Submit Buttons */}
      <HStack justify='flex-end' spacing={4}>
        <Button
          variant='outline'
          onClick={onCancel}
          isDisabled={isSubmitting || saving}
        >
          Cancel
        </Button>
        <Button
          type='submit'
          colorScheme='blue'
          isLoading={isSubmitting || saving}
          loadingText='Saving...'
        >
          Save Changes
        </Button>
      </HStack>
    </EditResearchForm>
  )
}

export default EditResearchPage
